module.exports = __webpack_public_path__ + "assets_app/img/key-3.b4e7678a.svg";